import type {
  NumberEmployeesSegmentationValues,
  PrevPayrollProviderValues,
  IndustryIdentificationValues,
  IntentStepValues,
} from 'packages/signup/components/SurveyQuestions';
import type { ContextContents } from '../signupProvider';

const calculateProgressPercentage = (signupContext: ContextContents) => {
  const {
    numberEmployeesSegmentation,
    prevPayrollProvider,
    industryIdentification,
    intentStep,
    hideIntentQuestion,
  } = signupContext;

  const answers: (
    | NumberEmployeesSegmentationValues
    | PrevPayrollProviderValues
    | IndustryIdentificationValues
    | IntentStepValues
    | undefined
  )[] = [
    numberEmployeesSegmentation,
    prevPayrollProvider,
    industryIdentification,
    hideIntentQuestion ? ('yes' as IntentStepValues) : intentStep,
  ];

  return answers.map(ans => (ans ? 100 / answers.length : 0)).reduce((a, b) => a + b);
};

export default calculateProgressPercentage;
